import React from "react";
import PropTypes from "prop-types";
import { SelectField } from "cxa-form-field";
import { injectIntl, intlShape } from "react-intl";
import { reduxForm } from "redux-form";
import messages from "components/messagesDescription";
import { compose } from "recompose";
import { connect } from "react-redux";

const enhance = compose(
  connect((state, props) => ({
    form: props.formName,
    enableReinitialize: props.enableReinitialize || true,
  })),
  reduxForm()
);

const PlanYearSelectField = ({ benefitPlans, intl }) => (
  <form>
    <SelectField
      label={intl.formatMessage(messages.planYearDescription)}
      name="benefitPeriod"
      inlineBoxed
      items={benefitPlans.map(item => ({
        value: item.planID,
        label: item.planName,
      }))}
    />
  </form>
);

PlanYearSelectField.propTypes = {
  benefitPlans: PropTypes.array.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(enhance(PlanYearSelectField));



// WEBPACK FOOTER //
// ./components/claim/widgets/PlanYearSelectField.js